import { useContext, useEffect, useState } from "react";

import {
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";

import Btn from "../../../../components/buttons/Btn";
import TextFieldErp from "../../../../components/basics/TextFieldErp";
import SelectErp from "../../../../components/basics/SelectErp";
import { ProdutoContext } from "../contexts/ProdutoContext";
import { validNotNull } from "../../../../utils/validations";
import { notify } from "../../../../utils/notify";
import MaskService from "../../../../utils/mask/maskService";

export default function ModalProdutoOutroFornecedor({
  open,
  setOpen,
  rowEdit,
  setRowEdit,
  ableToSelect,
}) {
  const {
    //Principal
    mainStockUnit,

    listSupplier,
    loadingInputs,
    supplierOthers,
    setSupplierOthers,
    listUnits,
  } = useContext(ProdutoContext);

  const [supplierModal, setSupplierModal] = useState(null);
  const [supplierRefModal, setSupplierRefModal] = useState("");
  const [purchaseUnitModal, setPurchaseUnitModal] = useState(null);
  const [supplierDescriptionModal, setSupplierDescriptionModal] = useState("");
  const [supplierConversionFactorModal, setSupplierConversionFactorModal] =
    useState("1,00000");
  const [errorsModal, setErrorsModal] = useState({});
  const [allowedList, setAllowedList] = useState([]);

  useEffect(() => {
    let updatedList = listSupplier.filter((listItem) => {
      return ableToSelect.includes(listItem.id);
    });

    setAllowedList(updatedList);
  }, [listSupplier, ableToSelect]);

  useEffect(() => {
    if (!rowEdit || !rowEdit.data) {
      setSupplierModal(null);
      setSupplierRefModal("");
      setPurchaseUnitModal(null);
      setSupplierDescriptionModal("");
      return;
    }

    const { data } = rowEdit;

    setSupplierRefModal(data.refforn || "");
    setSupplierDescriptionModal(data.descricaofornecedor || "");
    setSupplierConversionFactorModal(
      MaskService.toMask(
        "decimal",
        parseFloat(data.fator_conversao || 1).toFixed(5),
        5
      )
    );
  }, [rowEdit, listSupplier]);

  useEffect(() => {
    if (!rowEdit || !rowEdit.data || !rowEdit.data.idfornecedor) return;

    setSupplierModal(
      listSupplier.find(
        (option) =>
          option.id === rowEdit.data.idfornecedor ||
          option.id === rowEdit.data.id
      ) || null
    );
  }, [rowEdit, listSupplier]);

  useEffect(() => {
    if (!rowEdit || !rowEdit.data || !rowEdit.data.unidade_compra) {
      setPurchaseUnitModal(null);

      return;
    }

    setPurchaseUnitModal(
      listUnits.find((option) => {
        return option.un === rowEdit.data.unidade_compra;
      }) || null
    );
  }, [rowEdit, listUnits]);

  const handleCloseModal = () => {
    setOpen(false);
    setRowEdit(null);
  };

  const handleAdd = () => {
    const validationInput = validNotNull([
      { key: "supplierModal", value: supplierModal },
      { key: "purchaseUnitModal", value: purchaseUnitModal },
    ]);

    setErrorsModal({
      ...validationInput.errorsValidation,
      accordionInput: validationInput.error,
    });
    if (validationInput.error) {
      return notify(
        "Verifique se os campos Obrigatorios estão preenchidos corretamente."
      );
    }
    const body = {
      idfornecedor: supplierModal.id,
      refforn: supplierRefModal,
      unidade_compra: purchaseUnitModal?.un ?? "", //2 max
      fator_conversao: supplierConversionFactorModal
        ? MaskService.removeMaskDecimal(supplierConversionFactorModal, 5)
        : null, //18,2
      descricaofornecedor: supplierDescriptionModal,
    };

    if (rowEdit && (rowEdit.index || rowEdit.index === 0)) {
      body.id = rowEdit.data.id || null;

      if (rowEdit.index !== -1) {
        const copy = [...supplierOthers];
        copy[rowEdit.index] = body;
        setSupplierOthers(copy);
      }
    } else {
      setSupplierOthers((current) => [...current, body]);
    }

    setSupplierModal(null);
    setSupplierRefModal("");
    setPurchaseUnitModal(null);
    setSupplierDescriptionModal("");
    setSupplierConversionFactorModal("1,00000");
    setOpen(false);
    setRowEdit(null);
  };

  return (
    <>
      <Dialog
        open={open}
        maxWidth="lg"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Cadastro de Fornecedor
          {rowEdit && rowEdit.id ? `: (${rowEdit.id})` : ""}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item sm={6} xs={12}>
              <SelectErp
                error={errorsModal.supplierModal || false}
                helperText={errorsModal.supplierModal || ""}
                loading={loadingInputs.listSupplier || false}
                label="Fornecedor"
                value={supplierModal}
                setValue={setSupplierModal}
                optionsList={allowedList}
                descriptionField="apelido"
              />
            </Grid>

            <Grid item sm={6} xs={12}>
              <TextFieldErp
                label="Ref. Fornecedor"
                maxLength={20}
                value={supplierRefModal}
                setValue={setSupplierRefModal}
              />
            </Grid>

            <Grid item sm={6} xs={12}>
              <SelectErp
                error={errorsModal.purchaseUnitModal || false}
                helperText={errorsModal.purchaseUnitModal || ""}
                loading={loadingInputs.listUnits || false}
                label="Unidade Compra"
                value={purchaseUnitModal}
                setValue={setPurchaseUnitModal}
                optionsList={listUnits}
                descriptionField="descricao"
              />
            </Grid>

            {mainStockUnit &&
            purchaseUnitModal &&
            mainStockUnit.id !== purchaseUnitModal.id ? (
              <Grid item sm={6} xs={12}>
                <TextFieldErp
                  error={
                    errorsModal.supplierConversionFactorModal ? true : false
                  }
                  helperText={errorsModal.supplierConversionFactorModal || ""}
                  label="Fator de Conversão"
                  maxLength={14}
                  value={supplierConversionFactorModal}
                  setValue={setSupplierConversionFactorModal}
                  mask="decimal"
                  decimals={5}
                />
              </Grid>
            ) : (
              <></>
            )}

            <Grid item sm={6} xs={12}>
              <TextFieldErp
                label="Descrição no Fornecedor"
                maxLength={60}
                value={supplierDescriptionModal}
                setValue={setSupplierDescriptionModal}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Btn label="Cancelar" bgcolor="tertiary" onClick={handleCloseModal} />
          <Btn label="Salvar" onClick={handleAdd} />
        </DialogActions>
      </Dialog>
    </>
  );
}
